import { render, staticRenderFns } from "./SGPGraficoComponent.vue?vue&type=template&id=11f6bd76"
import script from "./SGPGraficoComponent.vue?vue&type=script&lang=js"
export * from "./SGPGraficoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports